import { assertUnreachable } from '@dreryk/react-common';

import { CommonStatisticsCode } from '../list/StatisticsListTable.types';

import { GenerateStatisticsFormController } from './GenerateStatisticsForm.types';
import { GenerateHealthcarePractitionerCashReportStatisticsButton } from './buttons/GenerateHealthcarePractitionerCashReportStatisticsButton';
import { GenerateHealthcarePractitionerSettlementDetailedStatisticsButton } from './buttons/GenerateHealthcarePractitionerSettlementDetailedStatisticsButton';
import { GenerateHealthcarePractitionerSettlementGeneralStatisticsButton } from './buttons/GenerateHealthcarePractitionerSettlementGeneralStatisticsButton';
import { GenerateHealthcareProviderDailyVisitStatisticsButton } from './buttons/GenerateHealthcareProviderDailyVisitStatisticsButton';
import { GeneratePractitionerDailyAppointmentOperationStatisticsButton } from './buttons/GeneratePractitionerDailyAppointmentOperationStatisticsButton';
import { GeneratePractitionerDailyCoexistentDiagnosisStatisticsButton } from './buttons/GeneratePractitionerDailyCoexistentDiagnosisStatisticsButton';
import { GeneratePractitionerDailyMainDiagnosisStatisticsButton } from './buttons/GeneratePractitionerDailyMainDiagnosisStatisticsButton';
import { GeneratePractitionerDailyVisitStatisticsButton } from './buttons/GeneratePractitionerDailyVisitStatisticsButton';

export type GenerateStatisticsModalConfirmButtonProps = Pick<GenerateStatisticsFormController, 'handleSubmit'> & {
   readonly code: CommonStatisticsCode;
   readonly onSuccess: VoidFunction;
};

export const GenerateStatisticsModalConfirmButtonSwitch = (
   props: GenerateStatisticsModalConfirmButtonProps
): JSX.Element => {
   switch (props.code) {
      case 'HealthcarePractitionerCreateDailyAppointmentReport':
         return <GeneratePractitionerDailyAppointmentOperationStatisticsButton {...props} />;
      case 'DoctorDailyMainDiagnosisStatistics':
         return <GeneratePractitionerDailyMainDiagnosisStatisticsButton {...props} />;
      case 'DoctorDailyCoexistentDiagnosisStatistics':
         return <GeneratePractitionerDailyCoexistentDiagnosisStatisticsButton {...props} />;
      case 'HealthcareProviderDailyVisitStatistics':
         return <GenerateHealthcareProviderDailyVisitStatisticsButton {...props} />;
      case 'DoctorDailyVisitStatistics':
         return <GeneratePractitionerDailyVisitStatisticsButton {...props} />;
      case 'HealthcarePractitionerCashReportStatistics':
         return <GenerateHealthcarePractitionerCashReportStatisticsButton {...props} />;
      case 'HealthcarePractitionerCreateSettlementDetailedStatistics':
         return <GenerateHealthcarePractitionerSettlementDetailedStatisticsButton {...props} />;
      case 'HealthcarePractitionerCreateSettlementGeneralStatistics':
         return <GenerateHealthcarePractitionerSettlementGeneralStatisticsButton {...props} />;
      default:
         return assertUnreachable(props.code);
   }
};
